/**
 * @flow
 * @relayHash 04e8bca25764557c883be52ea8d3bd37
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteShowcaseAssetInput = {|
  assetId: string,
  clientMutationId?: ?string,
|};
export type DeleteShowcaseAssetMutationVariables = {|
  input: DeleteShowcaseAssetInput
|};
export type DeleteShowcaseAssetMutationResponse = {|
  +deleteShowcaseAsset: ?{|
    +isDeleted: ?boolean
  |}
|};
export type DeleteShowcaseAssetMutation = {|
  variables: DeleteShowcaseAssetMutationVariables,
  response: DeleteShowcaseAssetMutationResponse,
|};
*/


/*
mutation DeleteShowcaseAssetMutation(
  $input: DeleteShowcaseAssetInput!
) {
  deleteShowcaseAsset(input: $input) {
    isDeleted
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteShowcaseAssetInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteShowcaseAsset",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteShowcaseAssetPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "isDeleted",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "DeleteShowcaseAssetMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "DeleteShowcaseAssetMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "DeleteShowcaseAssetMutation",
    "id": null,
    "text": "mutation DeleteShowcaseAssetMutation(\n  $input: DeleteShowcaseAssetInput!\n) {\n  deleteShowcaseAsset(input: $input) {\n    isDeleted\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'ff76920ac971603e2ac912fdf0e6bfd9';
module.exports = node;
